module.exports = __webpack_public_path__ + "img/networkError.bb93177a.png";